export default {
    'byMovimentsForm.form.filterByData': 'Filtrar por Data de (O.S.)',
    'byMovimentsForm.form.filterByData.entry': 'Entrada',
    'byMovimentsForm.form.filterByData.authorization': 'Autorização',
    'byMovimentsForm.form.filterByData.closing': 'Fechamento',
    'byMovimentsForm.form.situation': 'Situação da O.S.',
    'byMovimentsForm.form.situation.authorized': 'Autorizados',
    'byMovimentsForm.form.situation.closed': 'Fechados',
    'byMovimentsForm.form.situation.open': 'Abertos',
    'byMovimentsForm.form.situation.checkbox.parts': 'Peças',
    'byMovimentsForm.form.situation.checkbox.suppliedParts': 'Peças Fornecidas',
    'byMovimentsForm.form.situation.checkbox.services': 'Serviços',
    'byMovimentsForm.form.situation.checkbox.the3rd': 'Terceiros',
    'byMovimentsForm.form.situation.checkbox.directSale': 'Venda Direta',
    'byMovimentsForm.form.reportYype': 'Selecione o Tipo de Relatório',
    'byMovimentsForm.form.reportYype.salesmanEstimator': 'Orçamentista/Vendedor',
    'byMovimentsForm.form.reportYype.employeePerItem': 'Funcionário por item da O.S.',
    'byMovimentsForm.form.reportYype.paintedPiece': 'Peça Pintada',
    'byMovimentsForm.form.selectCalculationType.title': 'Selecione o tipo de cálculo',
    'byMovimentsForm.form.selectCalculationType.baseValue': 'Valor Base',
    'byMovimentsForm.form.selectCalculationType.netValue': 'Valor Líquido',
    'byMovimentsForm.form.selectCalculationType.checkbox.detailItemsSold': 'Detalhar Itens Vendidos',
    'byMovimentsForm.form.selectCalculationType.checkbox.inhibitNetValue': 'Inibir Valor Líquido',
}